/**
 * Single source of truth for which build this bundle is: the release tag HEAD
 * carried, else `commit-<short sha>` on an untagged build (dev, PR previews,
 * local), else `undefined` when git could answer neither. `scripts/git-release.mjs`
 * resolves both values at build time; `/version.json` carries them raw, its
 * `release` empty on an untagged build.
 *
 * The commit fallback exists because "no release" cannot tell two dev builds
 * apart: a survey record or an error from dev has to name the code it ran, or
 * it cannot be matched to a deploy (#1355). It is prefixed so it never reads as
 * a release tag -- the analysis sorts `trendaro-*` tags by date and must place
 * anything else apart.
 *
 * Normalized here so no consumer has to know the trap: the shell assignment in
 * `git:release` always defines both variables, so a missing value is the empty
 * string. Left as-is, Sentry would treat `""` as a release name and GA4 would
 * report a build with a blank version. Both failures are the stable-not-noisy
 * kind -- nothing looks broken -- which is exactly what this whole mechanism
 * exists to remove, so the rule is enforced once, at the boundary, rather than
 * re-derived by each consumer.
 */
const tag = import.meta.env.VITE_GIT_RELEASE_TAG;
const commit = import.meta.env.VITE_GIT_COMMIT;

export const RELEASE = tag || (commit ? `commit-${commit}` : undefined);
